<div class="drawer-content-screen import-file">
  <ng-content select="[import-file-header]"></ng-content>

  <div class="h-full overflow-x-auto pr-[5px]">
    <div class="flex flex-col gap-[1rem]">
      <div class="flex flex-col gap-[0.5rem]">
        <ngx-file-drop
          [multiple]="true"
          dropZoneLabel="Drop files here"
          (onFileDrop)="onDrop($event)"
          dropZoneClassName="h-[5rem] px-[1.25rem] py-[0.625rem] rounded-[0.5rem] border-2 border-dotted border-borderColor flex items-center justify-end"
          contentClassName="h-[auto] w-full">
          <ng-template
            ngx-file-drop-content-tmp
            let-openFileSelector="openFileSelector">
            <div class="flex items-center justify-center gap-[1rem]">
              <div class="flex w-full flex-col gap-[0.5rem]">
                @if (isLoading) {
                  <mat-progress-bar
                    class="w-full"
                    mode="determinate"
                    [value]="progressValue"></mat-progress-bar>
                }
                @if (textError) {
                  <mat-error class="error font-[14px]">
                    {{ textError | translate }}
                  </mat-error>
                }
              </div>
              <button
                [disabled]="isLoading"
                mat-flat-button
                color="primary"
                (click)="openFileSelector()">
                {{ 'Browse' | translate }}
              </button>
            </div>
          </ng-template>
        </ngx-file-drop>
        @if (filesError) {
          <mat-error class="font-[14px]">
            {{ 'invalidFormat' | translate }} {{ filesError | translate }}
          </mat-error>
        }
      </div>
      <div>
        <div class="search-bar flex items-center justify-end gap-[0.5rem]">
          <button
            mat-icon-button
            (click)="reload()"
            matTooltip="{{ 'reload' | translate }}">
            <mat-icon>refresh</mat-icon>
          </button>
          <app-search-bar
            [fullWidth]="false"
            (searchEventEmitter)="searchEvent.emit(search)"
            (valueChangedEventEmitter)="onSearchValueChanged($event)"
            [search]="search"></app-search-bar>
        </div>
        <ng-content select="[import-file-content]"></ng-content>
      </div>
    </div>
  </div>
</div>
